import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFService, SFNotification } from 'utils/types';
import css from './ServiceSchedulerView.css';
import ConnectionPlaceholder from 'serviceCatalog/connectionProfile/ConnectionPlaceholder';
import Scheduler from '../Scheduler';
import ScrollToTopOnMount from 'common/ScrollToTopOnMount';
import ServiceHeader from 'serviceCatalog/serviceProfile/ServiceHeader';
import { isEmpty } from 'lodash';
import ProfileNotFound from '../../ProfileNotFound';

export default class ServiceSchedulerView extends React.Component {

  get content() {
    if ( !this.props.hasFetched ) return <ConnectionPlaceholder />;
    if ( isEmpty(this.props.service) ) {
      return <ProfileNotFound renderNotification={this.props.notification.render} />;
    }
    return (
      <Scheduler
        id={this.props.service.id}
        partyId={this.props.partyId}
        isService
        name={this.props.service.name}
        serviceCalendarInstruction={this.props.service.serviceCalendarInstruction}
        serviceCalendarEnabled={this.props.service.serviceCalendarEnabled}
        restrictToSectionId={this.props.restrictToSectionId}
        notification={this.props.notification}
        userTimeZone={this.props.userTimeZone}
        header={(
          <ServiceHeader
            uuid={this.props.service.uuid}
            kioskQueueSize={this.props.service.kioskQueueSize}
            kioskMaxWaitTime={this.props.service.kioskMaxWaitTime}
            kioskId={this.props.service.kioskId}
            kioskType={this.props.service.kioskType}
            displayStudentQueue={this.props.service.displayStudentQueue}
            name={this.props.service.name}
            serviceDisplayName={this.props.service.serviceDisplayName}
            isServiceMember={this.props.isServiceMember}
            isStudent={this.props.isStudent}
          />
        )}
      />
    );
  }

  render() {
    return (
      <div className={css['container']}>
        <ScrollToTopOnMount />
        {this.content}
      </div>
    );
  }
}

ServiceSchedulerView.propTypes = {
  service: SFService,
  hasFetched: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  partyId: SFEntityID.isRequired,
  restrictToSectionId: SFEntityID,
  notification: SFNotification.isRequired,
  userTimeZone: PropTypes.string.isRequired
};
